module.exports = __webpack_public_path__ + "img/Q4-image.8dab0675.png";